var moment = require('moment');
import { CalendarViewType, FilterState } from './Calendar-Interfaces'
export function addClassForExpireDate(row, endDate) {
    const curdate = new Date();
    const eventDate = new Date(endDate);
    if (eventDate < curdate) {
        row.setAttribute("class", "prev-events");
    }
}

export function eventRender(title: string, eventInfo: any, modalTemplate: string) {
    const description = eventInfo['eventDescription'];
    const calendarID = eventInfo['calendarID'];
    const calendarName = eventInfo['calendarName'];
    const duration = eventInfo['Duration'];
    const eventID = eventInfo['CalendarEventsID'];
    const calendarInfoHTML = `<span class="h6-style"><button type="button" data-calendar-id="${calendarID}" class="un-button primary-link">${calendarName}</button></span>`;
    const tag = eventInfo['tagName'];
    const location = eventInfo['eventLocation'];
    const locationTitle = eventInfo['eventLocationTitle'];
    const contactName = eventInfo['contactName'];
    const contactEmail = eventInfo['contactEmail'];
    const contactTitle = eventInfo['contactTitle'];
    const tagArray = tag.split("|");
    let tags = " ";
    for (let tag of tagArray) {
        tags = tags + `<span class="tag">${tag}</span> `
    }
    const tagHTML = tags ? tags : '';
    const descriptionHTML = description ?
        `<p>${description}</p>` : '';
    const locationHTML = location || locationTitle ?
        `<div class="contact-list-item rich-text half-margins"><p class="titling">Location</p>
            ${locationTitle ? `<h3 class="h5-style">${locationTitle}</h3>` : ''}${location ? `<p>${location}</p>` : ''}</div>` : '';
    const contactHTML = contactTitle || contactName || contactEmail ?
        `<div class="contact-list-item rich-text half-margins"><p class="titling">Contact Info</p>
            ${contactName ? `<h3 class="h5-style">${contactName}</h5>` : ''}
            ${contactTitle ? `<p>${contactTitle}</p>` : ''}
            ${contactEmail ? `<p><a href="mailto:${contactEmail}">${contactEmail}</a></p>` : ''}</div>`
        : '';
    let cleanDescription = description.replace(/<br *\/*>/gi, '\r');
    cleanDescription = cleanDescription.replace(/(<([^>]+)>)/gi, "");
    cleanDescription = decodeHTML(cleanDescription);

    let event = modalTemplate.replace(/{{title}}/g, title);
    event = event.replace(/{{eventId}}/g, eventID);
    event = event.replace(/{{duration}}/g, duration);
    event = event.replace(/{{calendarTag}}/g, calendarInfoHTML);
    event = event.replace(/{{shortDescription}}/g, descriptionHTML);
    event = event.replace(/{{description}}/g, descriptionHTML);
    event = event.replace(/{{tags}}/g, tagHTML);
    event = event.replace(/{{location}}/g, locationHTML);
    event = event.replace(/{{contacts}}/g, contactHTML);
    event = event.replace(/{{startDate}}/g, eventInfo['eventStartDate']);
    event = event.replace(/{{endDate}}/g, eventInfo['eventEndDate']);
    event = event.replace(/{{eventTitle}}/g, eventInfo['eventTitle']);
    event = event.replace(/{{locationCal}}/g, location);

    event = event.replace(/{{url_title}}/g, encodeURIComponent(eventInfo['eventTitle']));
    event = event.replace(/{{url_location}}/g, encodeURIComponent(location));
    event = event.replace(/{{url_description}}/g, encodeURIComponent(cleanDescription));
    event = event.replace(/{{url_start}}/g, encodeURIComponent(eventInfo['eventStartDate']));
    event = event.replace(/{{url_end}}/g, encodeURIComponent(eventInfo['eventEndDate']));
    return event;
}

function  decodeHTML (htmlString: string) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = htmlString;
    return textarea.value;

}


export function groupRowsByDate(calendarTable: HTMLTableElement, previousEventsBtn: HTMLButtonElement, viewMode: CalendarViewType) {
    if (viewMode == 'dayGridMonth') {
        previousEventsBtn.style.visibility = 'hidden';
        return;
    }
    if (calendarTable) {
        const tbody = calendarTable.querySelector("tbody");
        const rows = [].slice.call(tbody.rows);
        let currentHeading = null;
        let activeDateCount = 0;
        let activeDate = "";
        let curdate = new Date();
        curdate.setHours(0, 0, 0, 0);
        let eventDate;
        let isHidden = false;
        let isExpiredEvent = false;
        previousEventsBtn.style.visibility = 'hidden'
        previousEventsBtn.innerText = 'PREVIOUS EVENTS';
        const previousRows = []
        
        rows.forEach(row => {
            const isHeading = row.hasAttribute('data-date');
            if (isHeading) {
                activeDate = row.getAttribute('data-date');
                eventDate = new Date(activeDate + "T00:00:00");
                if (currentHeading) {
                    currentHeading.style.gridRow = `auto / span ${activeDateCount}`;
                    activeDateCount = 0;
                }
                currentHeading = row;
                const eventDateUTCMonth = eventDate.getUTCMonth().toString();
                const currentDateUTCMonth = curdate.getUTCMonth().toString();
                const eventDateUTCYear = eventDate.getUTCFullYear().toString();
                const currentDateUTCYear = curdate.getUTCFullYear().toString();
                isHidden = false;
                isExpiredEvent = false;
                if (eventDate < curdate) {
                    isExpiredEvent = true;
                    row.style.color = '#757575';
                    if ((viewMode === 'listMonth' && eventDateUTCMonth == currentDateUTCMonth && eventDateUTCYear == currentDateUTCYear) || viewMode === 'listAllYears') {
                        row.style.display = 'none';
                        isHidden = true;
                        previousRows.push(row)
                    }
                }
            }
            else {
                row.innerHTML = row.innerHTML.replace(/{{dateString}}/g, activeDate);
                const activeDateObj = new Date(activeDate);
                const dateHTML = `<p class="titling">${activeDateObj.toLocaleString('en-us', { weekday: 'long', timeZone: 'UTC' })}</p><p class="h1-style event-modal-header-date-text">${activeDateObj.toLocaleString('en-us', { month: 'numeric', day: '2-digit', year: 'numeric', timeZone: 'UTC' }).replace(/\//g, `<span class="date-slash lighter-slash">/</span>`)}</p>`;
                row.innerHTML = row.innerHTML.replace(/{{currentDate}}/g, dateHTML);
                if (activeDateCount >= 0 && isHidden) {
                    row.style.display = 'none';
                }
                if (activeDateCount >= 0 && isExpiredEvent) {
                    row.setAttribute("class", "prev-events calendar-event-row");
                }
                activeDateCount++;
            }
            row.style.visibility = 'visible';
        });
       
        if (previousRows.length > 0) {
            previousEventsBtn.style.visibility = viewMode === 'listAllYears' && rows.length === previousRows.length ? 'hidden' : 'visible';
        }

        if (viewMode == 'listAllYears') {


            // Select all elements with the class 'fc-list-heading' and convert the NodeList into an array
            const headingList = Array.from(document.getElementsByClassName('fc-list-heading'));

            // Array containing names of months
            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

            // Iterate over each element with the class 'fc-list-heading'
            headingList.forEach(row => {
                const mainDatEl = row.querySelector('.heading-main-date');
                if (!mainDatEl) {
                    const rowDate = row.getAttribute('data-date');
                    const rowDateStr = new Date(rowDate);
                    const element = document.createElement('span');
                    const widgetEl = row.querySelector('.fc-widget-header');
                    element.classList.add('fc-list-heading-main');
                    element.classList.add('heading-main-date');
                    element.innerHTML = `${monthNames[rowDateStr.getMonth()]} ${rowDateStr.getFullYear()}`;
                    widgetEl.append(element);
                }
            })
         

        }
        
        if (currentHeading) {
            currentHeading.style.gridRow = `auto / span ${activeDateCount}`;
        }
    }
}

export function modalContentHtml(event) {
    const momentDate = moment(event.extendedProps.eventStartDate);
    const replacements = {
        eventId: event.extendedProps.CalendarEventsID || '',
        dateString: momentDate.format("YYYY-MM-DD"),
        currentDate: momentDate.format("MMMM D, YYYY"),
        duration: event.extendedProps.Duration || '',
        tags: event.extendedProps.tags.map(i => {
            return `<span class="tag">${i.name}</span>`
        }) || '',
        title: event.title || '',
        description: event.extendedProps.eventDescription || '',
        location: event.extendedProps.eventLocation || event.extendedProps.eventLocationTitle ?
        `<div class="contact-list-item rich-text half-margins"><p class="titling">Location</p>
            ${event.extendedProps.eventLocationTitle ? `<h3 class="h5-style">${event.extendedProps.eventLocationTitle}</h3>` : ''}${event.extendedProps.eventLocation ? `<p>${event.extendedProps.eventLocation}</p>` : ''}</div>` : '',
        contacts: event.extendedProps.contactTitle || event.extendedProps.contactName || event.extendedProps.contactEmail ?
            `<div class="contact-list-item rich-text half-margins"><p class="titling">Contact Info</p>
            ${event.extendedProps.contactName ? `<h3 class="h5-style">${event.extendedProps.contactName}</h5>` : ''}
            ${event.extendedProps.contactTitle ? `<p>${event.extendedProps.contactTitle}</p>` : ''}
            ${event.extendedProps.contactEmail ? `<p><a href="mailto:${event.extendedProps.contactEmail}">${event.extendedProps.contactEmail}</a></p>` : ''}</div>`
            : '',
        url_title: encodeURIComponent(event.title || ''),
        url_start: encodeURIComponent(moment(event.start).toISOString()),
        url_end: encodeURIComponent(moment(event.end).toISOString()),
        url_location: encodeURIComponent(event.extendedProps.location || ''),
        url_description: encodeURIComponent(event.extendedProps.description || '')
    };
    const activeDateObj = new Date(event.extendedProps.eventStartDate);
    const dateHTML = `<p class="titling">${activeDateObj.toLocaleString('en-us', { weekday: 'long', timeZone: 'UTC' })}</p><p class="h1-style event-modal-header-date-text">${activeDateObj.toLocaleString('en-us', { month: 'numeric', day: '2-digit', year: 'numeric', timeZone: 'UTC' }).replace(/\//g, `<span class="date-slash lighter-slash">/</span>`)}</p>`;
    const template = `
    <div class="dayGridModalContent" data-modal-contents="${replacements.eventId}-${replacements.dateString}">
        <div class="event-modal-header blue">
            <div class="flex-between align-end event-modal-header-info">
                <div class="event-modal-header-date">${dateHTML}</div>
                <p class="h4-style">${replacements.duration}</p>
            </div>
        </div>
        <div class="event-modal-block">
            ${replacements.tags}
            <div class="event-modal-contents has-atc">
                <div class="event-modal-contents-main">
                    <div class="rich-text event-modal-info event-modal-block">
                        <h2 class="event-modal-heading">${replacements.title}</h2>
                        <div class="intro">
                            ${replacements.description}
                        </div>
                    </div>
                    <div class="contact-list event-modal-block">
                        ${replacements.location}
                        ${replacements.contacts}
                    </div>
                </div>
                <div class="event-modal-contents-aside">
                    <h3 class="h6-style">
                        Add to Calendar
                    </h3>
                    <ul class="no-bullets no-margins">
                        ${['apple', 'outlook', 'outlookcom', 'google', 'yahoo'].map(service => `
                            <li>
                                <a target="_blank" rel="noopener" href="https://calndr.link/d/event?service=${service}&timezone=America%2FChicago&title=${replacements.url_title}&start=${replacements.url_start}&end=${replacements.url_end}&location=${replacements.url_location}&calname=${replacements.url_title}&description=${replacements.url_description}">
                                    ${service.charAt(0).toUpperCase() + service.slice(1)}
                                </a>
                            </li>
                        `).join('')}
                    </ul>
                </div>
            </div>
        </div>
    </div>
`;

    return template.trim();
}

export function showPrevious(calendarTable, previousEventsBtn, viewMode) {
    previousEventsBtn.focus();
    if ((calendarTable && previousEventsBtn.innerText == 'PREVIOUS EVENTS')) {
        const rows = [].slice.call(calendarTable.rows);
        let currentHeading = null;
        let activeDateCount = 0;
        let activeDate = "";
        let curdate = new Date();
        curdate.setHours(0, 0, 0, 0);
        let eventDate;
        let isHidden = false;
        rows.forEach(row => {
            const isHeading = row.hasAttribute('data-date');
            if (isHeading) {
                activeDate = row.getAttribute('data-date');
                eventDate = new Date(activeDate + "T00:00:00");
                if (currentHeading) {
                    activeDateCount = 0;
                }
                currentHeading = row;
                if (eventDate < curdate) {
                    row.style.display = '';
                    row.style.color = '#757575';
                    isHidden = true;
                }
                else {
                    isHidden = false;
                }
            }
            else {
                if (activeDateCount >= 0 && isHidden)
                    row.style.display = '';
                activeDateCount++;
            }

        });
        previousEventsBtn.innerText = 'UPCOMING EVENTS';
    }
    else {
        groupRowsByDate(calendarTable, previousEventsBtn, viewMode);
    }
}
export function toggleCalendarView(currentView: CalendarViewType): CalendarViewType {
    switch (currentView) {
        case 'listDay':
            return 'dayGridDay';
        case 'dayGridDay':
            return 'listDay';
        case 'listMonth':
            return 'dayGridMonth';
        case 'dayGridMonth':
            return 'listMonth';
        default:
            return currentView; // or you can choose to return a default view like 'dayGridMonth'
    }
}

// Helper function to determine which view to use
export function getCalendarView(filterState: FilterState, currentView: CalendarViewType, prevMode: CalendarViewType): CalendarViewType {

    if (filterState.date) {
        // Date is selected → prefer "day" views
        if (!currentView) return 'listDay';

        if (currentView === 'listMonth') return 'listDay';
        if (currentView === 'dayGridMonth' || currentView === 'dayGridWeek') return 'dayGridDay';

        return currentView;
    } else {
        // No date → prefer "month" views
        if (!currentView) return 'listMonth';

        if (currentView === 'listDay') return 'listMonth';
        if (currentView === 'dayGridDay') return prevMode;

        return currentView;
    }
}
